import React, { useState, useEffect } from "react";
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { app } from "../Firebase/Firebaseapp";
import { Link } from "react-router-dom";

const fireStorage = getStorage(app);

const Comparisoncar21d = ({ car1,car2 }) => {
  const [imageurl, setImageUrl] = useState();
  const [imageurl2, setImageUrl2] = useState();

  const getBooksImg = (path) => {
    return getDownloadURL(ref(fireStorage, path));
  };

  useEffect(() => {
    getBooksImg(car1.carImage).then((url) => setImageUrl(url));
    getBooksImg(car2.carImage).then((url) => setImageUrl2(url));
  }, [car1,car2]);
  return (
    <>
    {/* /:carID1?/:carID2 */}
      <Link to={`/Comparison/${car1.id}/${car2.id}`}  className=" w-[100%] flex flex-col sm:flex-row ">

      <div class=" max-w-md overflow-hidden rounded-lg bg-white shadow sm:w-[40%] mx-3 mt-2 ">
    
          <img src={imageurl && imageurl} class="aspect-video w-full object-cover" alt="" />
          <div class="p-4">
            {/* <p class="mb-1 text-sm text-primary-500">Andrea Felsted • <time>18 Nov 2022</time></p> */}
            <h3 class="text-xl font-medium text-gray-900">
              {car1 && car1.Name}{" "}
            </h3>
            <h3 class="text-xl font-medium text-gray-900">
              Price : {car1 && car1.Price}{" "}
            </h3>
            <p class="mt-1 text-gray-500">
              {car1 && car1.Description.slice(0, 80) + "......."}
            </p>
            <div class="mt-4 flex gap-2">
              <span class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-600">
                {car1 && car1.BodyType}
              </span>
              <span class="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-1 text-xs font-semibold text-indigo-600">
                {car1 && car1.Brand}
              </span>
              <span class="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-600">
                See More
              </span>
            </div>
          </div>
         
      </div>
    

      <div class=" sm:w-[10%] w-[100%] sm:h-[50vh] flex flex-col justify-center items-center m-2 ">
        <div className="vs bg-red-500 shadow-lg shadow- shadow-red-600 text-white text-[30px] px-5 rounded-full">
          vs
        </div>
      </div>

       <div class=" max-w-md overflow-hidden rounded-lg bg-white shadow sm:w-[40%] mx-3 mt-2 ">
       
          <img src={imageurl2 && imageurl2} class="aspect-video w-full object-cover" alt="" />
          <div class="p-4">
            {/* <p class="mb-1 text-sm text-primary-500">Andrea Felsted • <time>18 Nov 2022</time></p> */}
            <h3 class="text-xl font-medium text-gray-900">
              {car2 && car2.Name}{" "}
            </h3>
            <h3 class="text-xl font-medium text-gray-900">
              Price : {car2 && car2.Price}{" "}
            </h3>
            <p class="mt-1 text-gray-500">
              {car2 && car2.Description.slice(0, 80) + "......."}
            </p>
            <div class="mt-4 flex gap-2">
              <span class="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-600">
                {car2 && car2.BodyType}
              </span>
              <span class="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-1 text-xs font-semibold text-indigo-600">
                {car2 && car2.Brand}
              </span>
              <span class="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-600">
                See More
              </span>
            </div>
          </div>
       
      </div>
      </Link>
     
    </>
  );
};

export default Comparisoncar21d;
